import { RouterLink } from '@angular/router';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import {
  BankLimitProposalBadgeView,
  BankLimitRequestView,
  LIMIT_REQUEST_BUTTON_LABEL,
} from '@features/dashboard/dashboard-management/components/home-bank-limits-card/bank-limits-display.util';

/**
 * Ações do pedido de atualização de limites numa linha do card "Limites Bancários" (card 3787):
 * o botão "Pedir atualização ao banco" (ou "Pedido enviado em dd/MM · RFQ #N") e o selo da resposta
 * do banco aguardando conferência. As regras de quando aparece cada um ficam em
 * `bank-limits-display.util.ts`; aqui só desenha e avisa o card do clique.
 */
@Component({
  selector: 'app-home-bank-limit-update-actions',
  standalone: true,
  imports: [SharedModule, RouterLink],
  templateUrl: './home-bank-limit-update-actions.component.html',
  styleUrls: ['./home-bank-limit-update-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeBankLimitUpdateActionsComponent {
  readonly bankName = input.required<string>();
  readonly request = input<BankLimitRequestView | null>(null);
  readonly proposal = input<BankLimitProposalBadgeView | null>(null);
  /** Pedido deste banco em andamento (spinner no botão). */
  readonly requesting = input(false);

  readonly requestClick = output<void>();
  readonly proposalClick = output<string>();

  readonly buttonLabel = LIMIT_REQUEST_BUTTON_LABEL;
  /** A tela de RFQs abre o pedido pelo `?rfq=<número>` (deep link já existente). */
  readonly rfqsRoute = ['/dashboard/negotiation/rfqs'];
  readonly relationshipsRoute = ['/dashboard/market/banking-relationship/list'];
}
